import React from 'react';
import '../styles/InstallInstructionsModal.css';

const ShareIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#007aff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 16V4" />
    <polyline points="8 8 12 4 16 8" />
    <path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7" />
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="4" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

const MenuIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="5" r="1.6" />
    <circle cx="12" cy="12" r="1.6" />
    <circle cx="12" cy="19" r="1.6" />
  </svg>
);

/**
 * Shown on devices where the browser does not expose a native install prompt
 * (mainly iOS Safari, and iOS Chrome/Firefox). Explains how to add the app to
 * the home screen manually.
 */
function InstallInstructionsModal({ platform = 'other', onClose }) {
  let steps;
  if (platform === 'ios') {
    steps = (
      <ol className="install-steps">
        <li>
          Tap the <strong>Share</strong> button <ShareIcon /> in the browser toolbar.
        </li>
        <li>
          Scroll down and tap <strong>Add to Home Screen</strong> <PlusIcon />.
        </li>
        <li>
          Tap <strong>Add</strong> in the top-right corner.
        </li>
      </ol>
    );
  } else {
    steps = (
      <ol className="install-steps">
        <li>
          Open the browser menu <MenuIcon /> (top-right).
        </li>
        <li>
          Tap <strong>Install app</strong> or <strong>Add to Home screen</strong>.
        </li>
        <li>Confirm to finish installing UCMAApp.</li>
      </ol>
    );
  }

  return (
    <div className="install-modal-overlay" onClick={onClose}>
      <div
        className="install-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Install UCMAApp"
        onClick={(event) => event.stopPropagation()}
      >
        <button className="install-modal-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
        <div className="install-modal-header">
          <img src="/UCMA_maskable_512.png" alt="UCMAApp" className="install-modal-icon" />
          <div>
            <h3>Install UCMAApp</h3>
            <p>Add the app to your home screen for a full-screen experience.</p>
          </div>
        </div>
        {steps}
        <button className="install-modal-done" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}

export default InstallInstructionsModal;
